<template>
    <div class="indentDetail">
        <table-title>订单详情</table-title>
        <div class="indent">
            <table v-if="JSON.stringify(indentList) != '{}'" width="90%" border="1" class="borderColor" cellpadding="0" align="left" cellspacing="0">
                <tr>
                    <td>订单编号</td>
                    <td>{{indentList.orderNo}}</td>
                    <td>租借人</td>
                    <td>{{$options.filters['queryDict']('bizObjects','member',indentList.leaseeId)}}</td>
                    <td>标的物小类</td>
                    <td>{{$options.filters['queryDict']('target','type',indentList.targetType)}}</td>
                </tr>
                <tr>
                    <td>框架协议号</td>
                    <td>{{indentList.agreementNo}}</td>
                    <td>订单数量</td>
                    <td>{{indentList.orderAmount}}</td>
                    <td>确认数量</td>
                    <td>{{indentList.operateConfirmedAmount}}</td>
                </tr>
                <tr>
                    <td>状态</td>
                    <td>{{$options.filters['queryDict']('ENUM_MID-OPERATE-LEASE','order.LeaseOrderStatus',indentList.status)}}</td>
                    <td>预取交付时间</td>
                    <td>{{new Date(indentList.expectedDeliveryDate).Format("yyyy-MM-dd")}}</td>
                    <td>交付方式</td>
                    <td>{{$options.filters['queryDict']('ENUM_MID-OPERATE-LEASE','order.DeliveryMethod',indentList.deliveryMethod)}}</td>
                </tr>
                <tr>
                    <td>约定租期</td>
                    <td>{{indentList.rentTerm}}</td>
                    <td>是否清洗</td>
                    <td>{{$options.filters['queryDict'](null,'bitYesNo',indentList.cleaningRequired)}}</td>
                    <td>租借方联系人</td>
                    <td>
                        <span style="color:#2D8CF0;cursor:pointer" @click="queryContact(indentList.receiveContactId)">
                            <dict-box namespace="bizObjects" id="contact" :value="indentList.receiveContactId" />
                        </span>
                        <!-- <span style="color:#2D8CF0;cursor:pointer" @click="queryContact(indentList.receiveContactId)">{{$options.filters['queryDict']('bizObjects','contact',indentList.receiveContactId)}}</span> -->
                    </td>
                </tr>
                <tr>
                    <td>最大租赁额度</td>
                    <td>{{maxAmount}}</td>
                    <td>在租数量</td>
                    <td>{{leaseCar}}</td>
                    <td>所在区域</td>
                    <td>{{indentList.receiveArea?$options.filters['queryDict']('region','fullArea',indentList.receiveArea):''}}</td>
                </tr>
                <tr>
                    <td>收货地址</td>
                    <td colspan="3">{{indentList.receiveAddress}}</td>
                    <td>责任分区</td>
                    <td>
                        <dict-box namespace="bizObjects" id="respZone" :value="indentList.groupFlag" />
                        <!-- {{indentList.groupFlag?$options.filters['queryDict']('bizObjects','respZone',indentList.groupFlag):""}} -->
                        </td>
                </tr>
                <tr>
                    <td>备注</td>
                    <td colspan="5">{{indentList.leaseOrderComment}}</td>
                </tr>
                <tr>
                    <td>附件</td>
                    <td colspan="5"><a style="padding:0 10px" v-for="(file,index) in indentList.attachmentFiles" :key="file.fileId" @click="onDownloadFile(pltUtil.downloadUrl()+file.fileId)" title="点击下载该附件！">{{file.name}}</a></td>
                </tr>
            </table>
        </div>
        <div v-if="!paramsData.audit">
            <table-title>交付计划清单列表</table-title>
            <data-grid v-if="showTable" ref="lockOver" :columns="cols" :queryParams="{}" :autoLoad="false" :pagination="false" subListName :pageSize="0" :dataList="dataList">
                <template #default="{columns,data}">
                    <Table :columns="columns" :data="data" border stripe size="small" highlight-row>
                        <template slot-scope="{row}" slot="storageId">
                            <span style="color:#2D8CF0;cursor:pointer" @click="queryStorage(row)">{{$options.filters['queryDict']('bizObjects','warehouse',row.storageId)}}</span>
                        </template>
                        <template slot-scope="{row}" slot="status">
                            <Tag color="gold" v-if="row.status === 'NORMAL'">正常</Tag>
                            <Tag color="green" v-if="row.status === 'FINISH'">完成</Tag>
                            <Tag color="blue" v-if="row.status === 'TERMINATE'">中止</Tag>
                        </template>
                        <template slot-scope="{row}" slot="storageContactId">
                            <span style="color:#2D8CF0;cursor:pointer" @click="queryContact(row.storageContactId)">{{$options.filters['queryDict']('bizObjects','contact',row.storageContactId)}}</span>
                        </template>
                    </Table>
                </template>
            </data-grid>
        </div>
        <div v-if="paramsData.audit">
            <Divider orientation="left">审核确认</Divider>
            <Form ref="formValidates" :model="result" inline :label-width="100" :rules="ruleValidate">
                <FormItem label="确认结果" prop="checkResult">
                    <dict-select namespace="ENUM_MID-OPERATE-LEASE" id="orderService.LeaseOrderConfirmResult" :exclusion="[]" v-model="result.checkResult" />
                </FormItem>
                <FormItem label="备注">
                    <Input v-model="result.checkComment" type="textarea" style="width:300px" />
                </FormItem>
            </Form>
        </div>

        <div style="marign-top:20px;text-align:center">
            <Button type="primary" @click="submit" v-if="paramsData.audit">提交</Button>
            <Button type="warning" style="margin-left:10px" @click="goBlack()">返回</Button>
        </div>
        <contact-detail ref="queryContactRef" />
        <storage-detail ref="queryStorageRef" />
        <preview-image ref="previewImageRef" />
    </div>
</template>

<script>
import tableTitle from 'components/tableTitle/tableTitle.vue'
import dataGrid from '@/components/datagrid.vue'
import contactDetail from '@/components/contact-detail'
import storageDetail from '@/components/storage-detail'
import dictSelect from '@/components/select/dict-select.vue'


export default {
    // name: 'indentDetail',
    props: ['paramsData'],
    components: {
        tableTitle,
        dataGrid,
        contactDetail,
        storageDetail,
        dictSelect
    },
    data() {
        return {
            leaseCar: "",//在租数量
            maxAmount: "",
            showTable: false,
            indentList: {},
            dataList: [],
            cityList: [],//框架协议
            result: {
                orderNo: "",
                checkResult: "",
                checkComment: ""
            },
            ruleValidate: {
                checkResult: [{ required: true, message: "请选择确认结果", trigger: 'change' }]
            },
            cols: [
                { title: '交付计划ID', key: 'id' },
                { title: '订单号', key: 'orderNo' },
                // { title: '仓库名称', slot: 'storageId' },
                { title: '标的物小类', key: 'targetType', dict: ['target', 'type', true], },
                { title: '标的物编码', key: 'targetCode', dict: ['target', 'targetCodeLease', true], },
                { title: '交付计划总数量', key: 'totalAmount' },
                { title: '已交付数量', key: 'finishAmount' },
                { title: '状态', slot: 'status' },
                { title: '物流任务ID', key: 'logisticTaskId' },
                { title: '起租方运费承担比例', key: 'receiverFreightRatio' },
                { title: '销售运费计算系数', key: 'salerFreightCalcRatio' },
                // { title: '仓库联系人', slot: 'storageContactId' },
            ]
        }
    },
    created() {
        // this.getDetail(this.paramsData.orderNo)
        // this.result.orderNo = paramsData.orderNo
    },
    async mounted() {
        this.getDetail(this.paramsData.orderNo)
        this.result.orderNo = this.paramsData.orderNo
        await this.dict.initDict([{ id: 'respZone', namespace: 'bizObjects' }, { id: 'contact', namespace: 'bizObjects' }, { id: 'warehouse', namespace: 'bizObjects' }, { id: 'order.LeaseOrderStatus', namespace: "ENUM_MID-OPERATE-LEASE" }]); // 初始化字典
        await this.getLeaseCar(this.paramsData.agreementNo)
    },
    methods: {
         onDownloadFile(url) {
            //请求数据返回附件类型（image/pdf/xls） 是image类型 调用图片预览功能
            this.getRequest(url, { responseType: 'blob' }).then(res => {
                let data = res.data || res;//兼容老系统导入附件文件
                let type = data.type.substring(0, 5);
                if (type === 'image') {
                    this.localUtil.downloadFile(data, data.type).then(cont => {
                        this.$refs['previewImageRef'].openModal(cont);
                    })
                } else {
                    window.location.href = url;
                }
            })
        },
        getDetail(orderNo) {

            let data = {
                url: "MID-OPERATE-LEASE/messageService/orderService/queryOrderDetail",
                body: { orderNo }
            }
            this.invoke(data).then(res => {
                if (res) {
                    this.showTable = true
                    this.indentList = res
                    this.dataList = res.deliveryPlans

                }
            })

        },
        // 查询在租数量和最大额度
        async getLeaseCar(frameRentId) {
            let data = {
                url: "http://CORE-CONTRACT/messageService/queryService/queryBillingQuantityByFrameRentId",
                body: { frameRentId }
            }
            let { billingAmount, maxAmount } = await this.invoke(data)
            this.leaseCar = billingAmount
            this.maxAmount = maxAmount
        },
        goBlack() {
            this.$emit('onFinish')
        },
        queryContact(storageContactId) {
            this.$refs['queryContactRef'].openModal(storageContactId)
        },
        queryStorage(row) {
            this.$refs['queryStorageRef'].openModal(row.storageId)
        },
        // 提交
        submit() {
            this.$refs['formValidates'].validate((valid) => {
                if (valid) {
                    let data = {
                        url: "http://MID-OPERATE-LEASE/messageService/orderService/orderCheck",
                        body: this.result
                    }
                    this.$Modal.confirm({
                        title: '确定要提交审核吗？',
                        onOk: () => {
                            this.invoke(data).then(res => {
                                this.goBlack()
                                this.result.checkComment = ""
                            })
                        },
                    });
                }
            })

        }
    }

}
</script>

<style lang="scss" scoped>
.indent {
    height: 325px;
}
.borderColor {
    margin-left: 10px;
    text-align: center;
    tr {
        height: 40px;
        td {
            width: 78px;
        }
        td:nth-child(2n-1) {
            width: 90px;
            font-weight: bold;
            background: #c6e2ff;
        }
    }
}
</style>